import React from 'react';
import './App.css';
import 'moment/locale/es';

import { BrowserRouter as Router, Route } from "react-router-dom";
import Schedule from "./componentes/Schedule";
import Login from "./componentes/Login";
import Reset from "./componentes/Reset";
import SignUp from "./componentes/SignUp";
import DayDetail from "./componentes/DayDetail";
import Volunteer from "./componentes/Volunteer"
import Volunteers from "./componentes/Volunteers"
import Healing from "./componentes/Healing"
import { AuthProvider } from "./Auth";
import PrivateRoute from "./PrivateRoute";

import CssBaseline from '@material-ui/core/CssBaseline';


const App = () => {
  return (
    <AuthProvider>
      <CssBaseline />
      <Router>
        <div>
          <PrivateRoute exact path="/" component={Schedule} />
          <PrivateRoute exact path="/perfil" component={Volunteer} />
          <PrivateRoute exact path="/voluntarios" component={Volunteers} />
          <PrivateRoute exact path="/sanidad" component={Healing} />
          <PrivateRoute exact path="/day/:dayId" component={DayDetail} />
          <Route exact path="/reset" component={Reset} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/signup" component={SignUp} />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App